// extracted by mini-css-extract-plugin
export default {"container":"CreateIssueFooter-module__container--C49xM","Checkbox":"CreateIssueFooter-module__Checkbox--RNE52"};